import { LeftOutlined, RightOutlined } from '@ant-design/icons'

import styles from './intake-forms-nav.module.scss'

type IntakeFormsNavProps = {
  title: string
  currentIndex: number
  total: number
  canPrev: boolean
  canNext: boolean
  disabled: boolean
  onPrev: () => void
  onNext: () => void
}

export const IntakeFormsNav = ({
  title,
  currentIndex,
  total,
  canPrev,
  canNext,
  disabled,
  onPrev,
  onNext,
}: IntakeFormsNavProps) => (
  <div className={styles.nav}>
    <button
      type='button'
      className={styles.arrow}
      aria-label='Previous form'
      disabled={disabled || !canPrev}
      onClick={onPrev}>
      <LeftOutlined />
    </button>
    <div className={styles.meta} aria-live='polite'>
      <span className={styles.title}>{title}</span>
      {total > 0 && <span className={styles.counter}>{`${currentIndex + 1} of ${total}`}</span>}
    </div>
    <button
      type='button'
      className={styles.arrow}
      aria-label='Next form'
      disabled={disabled || !canNext}
      onClick={onNext}>
      <RightOutlined />
    </button>
  </div>
)
